
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import Input from '@/components/Core/Input.vue';

  import { IErrorModel } from '@/models/errors.model';
  import { IPasswordRecoveryModel } from '@/models/recovery.model';
  import accountService from '../../services/account.service';

  @Component({
    components: {
      Input
    },
    computed: {
      ...mapGetters([
        'isLoading'
      ])
    }
  })
  export default class PasswordRecovery extends Vue {
    data() {
      return {
        studio: '',
        hasErrors: false,
        isSendingLoading: false,
        errors: new Array<IErrorModel>(),
        form: {} as IPasswordRecoveryModel
      }
    };

    created() {
      this.$data.studio = this.$data.RCEnvironment.VUE_APP_PARTNER_NAME;
    }

    sendEmail() {
      if (this.$data.isSendingLoading) {
        return;
      }

      this.$store.dispatch("updateIsLoading", true);
      this.$data.isSendingLoading = true;
      this.$data.errors = new Array<IErrorModel>();
      this.$data.hasErrors = false;

      setTimeout(() => {
        const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "password/password-recovery";

        accountService.post<IPasswordRecoveryModel, object>(this, url, this.$data.form)
          .then(() => {
            this.$store.dispatch("updateIsLoading", false);
            this.$data.isSendingLoading = false;
            this.$router.push({ name: 'PasswordRecoverySent' });
          })
          .catch(error => {
            this.$data.hasErrors = true;
            this.$data.errors = error.data.ErrorMessages;
            this.$data.isSendingLoading = false;
            this.$store.dispatch("updateIsLoading", false);
          });
      }, 300);
    }

    public updateEmailValue(parameter: string, email: string) {
      this.$set(this.$data.form, 'email', email);
    }
  }
